import {GridColDef} from '@mui/x-data-grid';
import dayjs from 'dayjs';
import Status from '../../../ui/status/Status';
import {DATE_FORMAT} from '../../../shared/constants';
import {ContractDto} from '../../../global/api';

export const CONTRACTS_TABLE_COLUMNS: GridColDef<ContractDto>[] = [
  {
    field: 'counter',
    headerName: '№',
    renderCell: ({row}) => row?.counter || '-',
  },
  {
    field: 'companyName',
    headerName: 'Заказчик',
    renderCell: ({row}) => row?.companyName || '-',
    sortable: false,
  },
  {
    field: 'contractNumber',
    headerName: '№ Договора',
    renderCell: ({row}) => row?.contractNumber || '-',
  },
  {
    field: 'serviceType',
    headerName: 'Вид работ',
    renderCell: ({row}) => row?.serviceType?.name || '-',
  },
  {
    field: 'startDate',
    headerName: 'Дата заключения',
    renderCell: ({row}) => row.startDate && dayjs(row.startDate).format(DATE_FORMAT),
  },
  {
    field: 'dueDate',
    headerName: 'Дата окончания',
    renderCell: ({row}) => row?.dueDate && dayjs(row.dueDate).format(DATE_FORMAT),
  },
  {
    field: 'statusCode',
    headerName: 'Статус',
    minWidth: 122,
    renderCell: ({row}) => {
      return (
        <Status
          entity="contract"
          border={row.statusCode === 'CREATED' || row.archived}
          code={row.archived ? 'ARCHIVED' : row.statusCode}
        />
      );
    },
  },
];
